import { render } from "./Checkboxes.vue?vue&type=template&id=47ccd144&scoped=true&ts=true"
import script from "./Checkboxes.vue?vue&type=script&lang=ts"
export * from "./Checkboxes.vue?vue&type=script&lang=ts"

import "./Checkboxes.vue?vue&type=style&index=0&id=47ccd144&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ccd144"]])

export default __exports__